/* @flow */

export default class RegisterLeadResponse {
  companyId: number;
  leadId: number;
  leadAlreadyExist: boolean;
}
